import { Routes } from '@angular/router';
import { EditSystemeIrrigationComponent } from './edit-systeme-irrigation/edit-systeme-irrigation.component';
import { ListeSystemesIrrigationsComponent } from './liste-systemes-irrigations/liste-systemes-irrigations.component';

export const SYSTEMES_IRRIGATIONS_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const SYSTEMES_IRRIGATIONS_ROUTES: Routes = [
    { path: '', component: ListeSystemesIrrigationsComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditSystemeIrrigationComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditSystemeIrrigationComponent, data: { roles: ['ORGANISME'] } }
];
